/**
 * Dashboard Plugin System - Utilities
 * 
 * Helper functions for the plugin system.
 */

// Development mode logging
const isDev = process.env.NODE_ENV !== 'production';

export const log = (...args: any[]) =>
  isDev && console.log('[PLUGIN-SYSTEM]', ...args);
